/* asee-b2b-tabs — as abas temáticas do bloco "What we paint" das 9 páginas B2B.
   Progressive enhancement: sem este arquivo, todos os painéis ficam visíveis empilhados
   (o CSS só esconde os painéis depois que a classe `is-ready` entra), então ninguém
   perde conteúdo se o script falhar.
   Teclado: setas andam entre as abas, Home e End vão para a primeira e a última.
   Link direto: #paintings=<slug> abre a aba correspondente ao carregar, para a line
   sheet ou um e-mail apontarem direto no tema certo. */
(function () {
  var HASH = 'paintings=';

  function setup(root) {
    var bar = root.querySelector('[role="tablist"]');
    if (!bar) return;
    var tabs = Array.prototype.slice.call(bar.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[role="tabpanel"]'));
    if (tabs.length < 2) return;
    root.classList.add('is-ready');

    function select(i, focus) {
      tabs.forEach(function (t, k) {
        var on = k === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
      });
      panels.forEach(function (pnl, k) { pnl.hidden = k !== i; });
      if (focus) tabs[i].focus();
      var slug = tabs[i].id.replace(/^tab-/, '');
      if (focus && history.replaceState) history.replaceState(null, '', '#' + HASH + slug);
      if (window.dataLayer) window.dataLayer.push({ event: 'b2b_paintings_tab', tab: slug });
    }

    bar.addEventListener('click', function (e) {
      var t = e.target.closest('[role="tab"]');
      if (!t) return;
      select(tabs.indexOf(t), true);
    });

    bar.addEventListener('keydown', function (e) {
      var i = tabs.indexOf(document.activeElement);
      if (i < 0) return;
      var n = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = (i + 1) % tabs.length;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = (i - 1 + tabs.length) % tabs.length;
      else if (e.key === 'Home') n = 0;
      else if (e.key === 'End') n = tabs.length - 1;
      if (n === null) return;
      e.preventDefault();
      select(n, true);
    });

    // estado inicial: o hash manda, senão a primeira
    var want = (location.hash || '').indexOf(HASH) > -1 ? location.hash.split(HASH)[1] : null;
    var start = 0;
    if (want) {
      var found = tabs.findIndex(function (t) { return t.id === 'tab-' + want; });
      if (found > -1) start = found;
    }
    select(start, false);
    if (want && start > 0) root.scrollIntoView({ block: 'start' });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-asee-tabs]'), setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
